"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2c-1.8889 0-3.655.6548-4.951 1.955C5.749 5.2593 5 7.1344 5 9.4287c0 1.8894.8715 3.7288 1.7625 5.2472.3272.5574.6765 1.0996 1.0256 1.6414.5636.8745 1.1265 1.748 1.5939 2.6828h5.236c.4675-.9348 1.0303-1.8083 1.5939-2.6828.3491-.5418.6984-1.084 1.0256-1.6414C18.1285 13.1574 19 11.318 19 9.4286c0-2.2942-.7491-4.1693-2.0491-5.4735C15.655 2.6547 13.8889 2 12 2zm-4.9631 8c-.204-1.6236.258-3.4585 1.4287-4.633C9.3413 4.4883 10.5752 4 12 4c1.4248 0 2.6587.4884 3.5344 1.367C16.7051 6.5414 17.167 8.3763 16.9631 10H7.0369zm2.461 5.2557C8.8133 14.2049 8.129 13.1544 7.6264 12h8.7472c-.5024 1.154-1.1867 2.204-1.8712 3.2543-.3754.576-.7509 1.1522-1.0965 1.7457h-2.8127c-.3453-.5929-.7203-1.1686-1.0953-1.7443zM9.2236 20h5.5571v2h-5.557v-2z"
  })];
};

exports.default = _default;